import { ResourceCategory } from '@core/grapql';
import { categoryNameToSlug } from '@core/resources';
import React, { ReactNode } from 'react';

import AtHomeIcon from './assets/atHome.inline.svg';
import CareConsultantsIcon from './assets/careConsultants.inline.svg';
import CareSupportIcon from './assets/careSupport.inline.svg';
import CareTechIcon from './assets/careTech.inline.svg';
import DebtIcon from './assets/debt.inline.svg';
import EstatePlanningIcon from './assets/estatePlanning.inline.svg';
import FacilityIcon from './assets/facility.inline.svg';
import FinanceIcon from './assets/finance.inline.svg';
import FinanceAssetsIcon from './assets/financeAssets.inline.svg';
import FinanceCreditCardsIcon from './assets/financeCreditCards.inline.svg';
import FinanceFraudProtectionIcon from './assets/financeFraudProtection.inline.svg';
import FinanceGovernmentBenefitsIcon from './assets/financeGovernmentBenefits.inline.svg';
import FinanceInsuranceIcon from './assets/financeInsurance.inline.svg';
import FinanceLoansIcon from './assets/financeLoans.inline.svg';
import FinanceServicesIcon from './assets/financeServices.inline.svg';
import GetStuffDoneIcon from './assets/getStuffDone.inline.svg';
import GiftsIcon from './assets/gifts.inline.svg';
import HealthIcon from './assets/health.inline.svg';
import HousingIcon from './assets/housing.inline.svg';
import LegalIcon from './assets/legal.inline.svg';
import MentalHealthIcon from './assets/mentalHealth.inline.svg';
import NutritionIcon from './assets/nutrition.inline.svg';
import PaidHelpersIcon from './assets/paidHelpers.inline.svg';
import PersonalAssetsIcon from './assets/personalAssets.inline.svg';
import PetsTooIcon from './assets/petsToo.inline.svg';
import PhysicalHealthIcon from './assets/physicalHealth.inline.svg';
import PrivateInsuranceIcon from './assets/privateInsuranse.inline.svg';
import WishesIcon from './assets/wishes.inline.svg';

export const getResourceCategoryIcon = (category: ResourceCategory, rootCategory?: ResourceCategory): ReactNode | undefined => {
  const categorySlug = categoryNameToSlug(category.name);
  const rootCategorySlug = rootCategory ? categoryNameToSlug(rootCategory.name) : undefined;
  if (rootCategorySlug === 'finance' && categorySlug === 'assets') return <FinanceAssetsIcon />;
  if (rootCategorySlug === 'finance' && categorySlug === 'credit-cards') return <FinanceCreditCardsIcon />;
  if (rootCategorySlug === 'finance' && categorySlug === 'fraud-protection') return <FinanceFraudProtectionIcon />;
  if (rootCategorySlug === 'finance' && categorySlug === 'government-benefits') return <FinanceGovernmentBenefitsIcon />;
  if (rootCategorySlug === 'finance' && categorySlug === 'insurance') return <FinanceInsuranceIcon />;
  if (rootCategorySlug === 'finance' && categorySlug === 'loans') return <FinanceLoansIcon />;
  if (rootCategorySlug === 'finance' && categorySlug === 'services') return <FinanceServicesIcon />;
  switch (categoryNameToSlug(category.name)) {
    case 'care-support': {
      return <CareSupportIcon />;
    }
    case 'health': {
      return <HealthIcon />;
    }
    case 'housing': {
      return <HousingIcon />;
    }
    case 'legal': {
      return <LegalIcon />;
    }
    case 'finance': {
      return <FinanceIcon />;
    }
    case 'care-consultants': {
      return <CareConsultantsIcon />;
    }
    case 'care-tech': {
      return <CareTechIcon />;
    }
    case 'get-stuff-done': {
      return <GetStuffDoneIcon />;
    }
    case 'gifts': {
      return <GiftsIcon />;
    }
    case 'paid-helpers': {
      return <PaidHelpersIcon />;
    }
    case 'pets-too': {
      return <PetsTooIcon />;
    }
    case 'debt': {
      return <DebtIcon />;
    }
    case 'personal-assets': {
      return <PersonalAssetsIcon />;
    }
    case 'private-insurance': {
      return <PrivateInsuranceIcon />;
    }
    case 'mental-health': {
      return <MentalHealthIcon />;
    }
    case 'nutrition': {
      return <NutritionIcon />;
    }
    case 'physical': {
      return <PhysicalHealthIcon />;
    }
    case 'at-home': {
      return <AtHomeIcon />;
    }
    case 'facility': {
      return <FacilityIcon />;
    }
    case 'planning': {
      return <EstatePlanningIcon />;
    }
    case 'wishes': {
      return <WishesIcon />;
    }
    default:
      return undefined;
  }
};
